import { useEffect } from 'react';
import type { NextRouter } from 'next/router';

import { setListingsPageImplementation } from './listingsPageProperties';
import { resolveSurfaceDocumentSignal } from './surfaceScripts';

export function useListingsPageImplementation(router: Pick<NextRouter, 'events' | 'pathname'>) {
  useEffect(() => {
    const updateImplementation = (url: string) => {
      const pathname = url.split(/[?#]/)[0];
      setListingsPageImplementation(resolveSurfaceDocumentSignal(pathname) === 'listings');
    };

    updateImplementation(router.pathname);
    router.events.on('beforeHistoryChange', updateImplementation);

    return () => router.events.off('beforeHistoryChange', updateImplementation);
  }, [router.events, router.pathname]);
}
